import React, { useState } from 'react';
import { Modal, Button } from 'semantic-ui-react';
import { StyledModal } from './SharedStyles';
import { copyToClipboard } from '../utils/clipboard';

const ShareModal = ({ open, onClose, taskLabel }) => {
  const [copySuccess, setCopySuccess] = useState('');
  const label = taskLabel || 'Check out this task list';

  const handleCopyLink = async () => {
    const success = await copyToClipboard(window.location.href);
    setCopySuccess(success ? 'Copied!' : 'Copy failed');
  };

  return (
    <StyledModal open={open} onClose={onClose}>
      <Modal.Header>Share Task</Modal.Header>
      <Modal.Content>
        <p>Share this task via:</p>
        <Button as="a" href={`mailto:?subject=${encodeURIComponent(label + ' - Didit')}&body=${encodeURIComponent(window.location.href)}`}>
          Email
        </Button>
        <Button as="a" href={`sms:?body=${encodeURIComponent(label + ' ' + window.location.href)}`}>
          SMS
        </Button>
        <Button onClick={handleCopyLink}>
          Copy Link
        </Button>
        {copySuccess && <p>{copySuccess}</p>}
      </Modal.Content>
    </StyledModal>
  );
};

export default ShareModal;
